import { Box, CircularProgress, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { Button } from '@atoms';
import { columns } from './utils';

interface ICSVTablePartProps {
  dataTable: any[];
  loading: boolean;
  inputRef: React.RefObject<any>;
}

const CSVTablePart: React.FC<ICSVTablePartProps> = ({ dataTable, loading, inputRef }) => {
  const onClickUpload = () => {
    inputRef.current?.click();
  };

  return (
    <>
      {loading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            bgcolor: 'rgba(255,255,255,0.7)',
            zIndex: 1301,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={40} />
          <Typography sx={{ ml: 2, fontSize: 14, color: '#464F60' }}>Uploading...</Typography>
        </Box>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        paddingX="32px"
        alignItems="center"
        sx={{ mt: '24px' }}
      >
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '20px',
            color: '#464F60',
            whiteSpace: 'normal',
            marginBottom: '18px',
          }}
        >
          Add New Results
        </Typography>
        <Button onClick={onClickUpload} sx={{ paddingX: '30px' }} variant="outlined" color="black">
          Replace CSV
        </Button>
      </Box>
      <Box sx={{ height: '290px', width: '100%', padding: '0 32px' }}>
        <DataGrid
          rows={dataTable}
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableDensitySelector
          disableVirtualization={false}
          hideFooter={true}
          autoHeight={false}
          checkboxSelection={false}
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '12px',
              fontWeight: 'bold',
              border: 'none',
            },
            '& .MuiDataGrid-cell, & .MuiDataGrid-cellContent': {
              fontSize: '12px',
              border: 'none',
            },
            '& .MuiDataGrid-virtualScroller': {
              overflowX: 'auto',
              overflowY: 'auto',
            },

            '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
              outline: 'none !important',
            },

            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'transparent',
            },

            height: '100%',
            width: '100%',
            border: 'none',
          }}
        />
      </Box>
    </>
  );
};

export default CSVTablePart;
